// extracted by mini-css-extract-plugin
module.exports = {"info":"__8xQtlmu6","searchKey":"KswYixxP"};